export default function videoSrc() {
    if(document.querySelector(".modal-constructor")) {
        const video = document.querySelector(".modal-constructor video");
        const close = document.querySelector(".modal-constructor .modal__close");
        const modalClose = document.querySelector(".modal-constructor .modal__bg");

        close.addEventListener("click", () => {
            const videoSrc = video.src;
            video.src = "";
            video.src = videoSrc;
        });

        modalClose.addEventListener("click", () => {
            const videoSrc = video.src;
            video.src = "";
            video.src = videoSrc;
        });
    }
}
